export const technologyTemplate = {
    image_base64: '',
    title_en: 'Technology',
    text_en: 'Some text',
    title_ukr: 'Технології',
    text_ukr: 'Трохи тексту'
}
